import React from 'react'
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate()
  const handleLogoutButton = () => {
    localStorage.clear();
    navigate("/")
  }
  return (
    <>
      <header className="nav_wrapper">
        <div className="container">
          <div className="nav_inner">
            <div className="main_logo" >
              <img src="assets/img/main_logo.svg" alt="logo" onClick={() => navigate("/")} />
            </div>
            <div className="nav_content">
              {window.location.pathname == "/seller-dashaboard" ? <>
                <FiLogOut className='text-white cst-logout-cls'
                  // data-bs-toggle="modal"
                  // data-bs-target="#signinModal"
                  onClick={() => handleLogoutButton()} />
              </> : <>
                <div className="social_icons">
                  <a href=""><img src="assets/img/youtube.svg" alt="youtube" /></a>
                  <a href=""><img src="assets/img/twitter.svg" alt="twitter" /></a>
                  <a href=""><img src="assets/img/discord.svg" alt="discord" /></a>
                  <a href=""><img src="assets/img/linkedin.svg" alt="linkedin" /></a>
                </div>
                <div className="term_policy">
                  <p className="nav_title" data-bs-toggle="modal" data-bs-target="#term_condition2">TERMS & CONDITIONS </p>
                  <p className="nav_title" data-bs-toggle="modal" data-bs-target="#privacy_policy2">PRIVACY POLICY </p>
                </div>
              </>}
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header